import type { TypesVersionInOut } from '@festina/configuration-general-types/configuration'
import type { ConfigurableServer, Optional } from '@festina-life/core'

export type BranchTypesInput = {
  typesVersionName: string
  typesVersionDescription: string
  typeVersionFile: File[]
  server: ConfigurableServer
}

// The backend has chosen not to expose this type in the API so we need to define it here.
export type LayerTypesVersionInOut = {
  _type: 'LayerTypesVersionInOut'
  layer: Optional<string>
  typesVersion: TypesVersionInOut
}

export type LayerTypesVersionsInOut = {
  _type: 'LayerTypesVersionsInOut'
  layerTypesVersions: LayerTypesVersionInOut[]
}

export const isLayerTypesVersionsInOut = (
  value: LayerTypesVersionInOut | TypesVersionInOut,
): value is LayerTypesVersionsInOut => value._type === 'LayerTypesVersionsInOut'

export const isTypesVersionInOut = (
  value: LayerTypesVersionInOut | TypesVersionInOut,
): value is TypesVersionInOut => value._type === 'TypesVersionInOut'
